import { AngularEditorConfig } from "@olga.n.sh/kolkov-angular-editor";
import { DocumentTextType, ReporterBrandColor } from "src/generated/graphql";

export const NW_URL = 'https://www.northwhistle.com/';
export const NW_PRIVACY_POLICY_URL = 'https://www.northwhistle.com/app-privacy/';
// Document templates now ship with the app (src/assets/docsTemplates) instead of being
// fetched from the external host https://public.northwhistle.com/docs
export const FTP_PUBLIC_PATH = './assets/docsTemplates';

export const DEFAULT_WHITE_COLOR = '#FFFFFF';
export const DEFAULT_LINK_COLOR = '#429EFF';
export const DEFAULT_BRAND_COLOR = '#1F42DD';

export const DEFAULT_BRAND_COLORS: ReporterBrandColor = {
  button: DEFAULT_BRAND_COLOR,
  buttonText: DEFAULT_WHITE_COLOR,
  header: DEFAULT_WHITE_COLOR,
  headerText: DEFAULT_BRAND_COLOR,
  link: DEFAULT_LINK_COLOR
};

export const ENABLED_LANGUAGES = [
  {key: 'de', label: 'Deutsch'},
  {key: 'da', label: 'Dansk'},
  {key: 'nb', label: 'Norsk'},
  {key: 'fi', label: 'Suomeksi'},
  {key: 'en', label: 'English'},
  {key: 'es', label: 'Español'},
  {key: 'fr', label: 'Français'},
  {key: 'it', label: 'Italiano'},
  {key: 'nl', label: 'Nederlands'},
  {key: 'pl', label: 'Polski'},
  {key: 'pt', label: 'Português'},
  {key: 'sv', label: 'Svenska'},
];

export const LANGUAGE_COUNTRY_FLAG_MAP = [
  {lang: 'de', country: 'de'},
  {lang: 'da', country: 'dk'},
  {lang: 'nb', country: 'no'},
  {lang: 'fi', country: 'fi'},
  {lang: 'en', country: 'en'},
  {lang: 'es', country: 'es'},
  {lang: 'fr', country: 'fr'},
  {lang: 'it', country: 'it'},
  {lang: 'nl', country: 'nl'},
  {lang: 'pl', country: 'pl'},
  {lang: 'pt', country: 'pt'},
  {lang: 'sv', country: 'se'},
];

// Not in use anymore
export const LANGUAGES_EXCLUDED_FROM_ADMIN_INTERFACE = [ 'da', 'nb', 'fi' ];
export const ENABLED_LANGUAGES_ADMIN_INTERFACE = [ 'de', 'en', 'es', 'fr', 'it', 'nl', 'pl', 'pt', 'sv' ];

export const PHONE_INPUT_PREFERED_COUNTRIES = ['de', 'dk', 'es', 'fi', 'fr', 'it', 'nl', 'no', 'pl', 'pt', 'se'];

export const PINCH_ZOOM_PROPERTIES = {
  'double-tap': true,
  overflow: 'visible',
  disableZoomControl: 'disable',
  backgroundColor: 'rgba(0,0,0,0)',
  wheel: false,
  listeners: 'auto',
};

export const DOCUMENT_LIST = [
  {
    type: DocumentTextType.LandingPageIntroduction,
    template: 'landing-page-intro',
    convertLineBreaks: false,
  },
  {
    type: DocumentTextType.LandingPageDetails,
    template: 'landing-page-details',
    convertLineBreaks: false,
  },
  {
    type: DocumentTextType.PersonalDataManagementPolicy,
    template: 'landing-page-policy-for-personal-data-management',
    convertLineBreaks: true,
  },
]

export type TEMPLATE_VARIABLES = {
  '%COMPANY-NAME%': string; // Company name (primary)

  '%DPO-NAME%'?: string; // DPO name (primary)
  '%DATA-PROTECTION-OFFICER%'?: string; // DPO name (legacy fallback)

  '%WB-RESPONSIBLE%'?: string; // Responsible person for whistleblowing (primary)
  '%WP-PROCESS-NAME%'?: string; // Responsible person for whistleblowing (legacy fallback)
  '%PERSON-RESPONSIBLE-FOR-WHISTLEBLOWING%'?: string; // Responsible person for whistleblowing (legacy fallback)
  
  '%NORTHWHISTLE-URL%': string; // Reporter direct link
  '%REPORTING-URL%': string; // Reporter direct link (primary)

  '%LINK-TO-INTRANET%'?: string; // Landing page link
  '%LANDING-PAGE-URL%'?: string; // Landing page link (primary)

  '%USER-INPUT-1%'?: string; // User input from form
}

// Default data if no template variable is available
// Should correspond directly with TEMPLATE_VARIABLES type
export const DOCUMENT_PLACEHOLDER = {
  'responsiblePersonForWhistleblowing': '%WB-RESPONSIBLE%',
  'dataProtectionOfficer': '%DPO-NAME%',
  'companyName': '%COMPANY-NAME%',
  'northwhistleUrl': '%NORTHWHISTLE-URL%',
  'intranetLink': '%LINK-TO-INTRANET%'
}

export const WYSIWYG_EDITOR_CONFIG: AngularEditorConfig = {
  enableToolbar: false,
  showToolbar: false,
  minWidth: '720px',
  editable: false,
  spellcheck: true,
  minHeight: '5rem',
  //maxHeight: '10rem',
  maxHeight: 'auto',
  translate: 'no',
  sanitize: false,
  toolbarPosition: 'top',
  defaultFontSize: '3',
  defaultParagraphSeparator: 'p',
  toolbarHiddenButtons: [
    [
      'strikeThrough',
      'subscript',
      'superscript',
      'fontName',
    ],
    [
      'fontSize',
      'textColor',
      'backgroundColor',
      'customClasses',
      'insertImage',
      'insertVideo',
      'insertHorizontalRule',
      'removeFormat',
      'toggleEditorMode'
    ]
  ]
};
